<section class="icip-walkthrough" id="walkthrough" aria-label="Product Walkthrough">
  <div class="icip-walkthrough__container">
    <div class="icip-walkthrough__header icip-reveal" appInView>
      <div class="icip-walkthrough__kicker">Product Walkthrough</div>
      <h2 class="icip-walkthrough__title">From setup to live calls in minutes.</h2>
    </div>

    <div class="icip-walkthrough__card icip-reveal" appInView>
      <div class="icip-walkthrough__steps">
        <button
          type="button"
          class="icip-walkthrough__step"
          *ngFor="let s of steps; let i = index"
          (click)="selectStep(i)"
          [class.is-active]="i === active"
        >
          <div class="icip-walkthrough__step-row">
            <div class="icip-walkthrough__step-num">{{ s.num }}</div>
            <div>
              <div class="icip-walkthrough__step-title">{{ s.title }}</div>
              <div class="icip-walkthrough__step-desc">{{ s.desc }}</div>
            </div>
          </div>

          <div
            class="icip-walkthrough__progress"
            *ngIf="i === active"
            [style.width.%]="progress"
            aria-hidden="true"
          ></div>
        </button>
      </div>

      <div class="icip-walkthrough__panel">
        <div class="icip-walkthrough__panel-inner" [attr.data-active]="active">
          <div class="icip-walkthrough__panel-enter" [class.is-enter]="panelEnter">
          <div class="icip-panel icip-panel--0" *ngIf="active === 0">
            <span class="icip-pointer" aria-hidden="true"></span>
            <div class="icip-panel__badge">STEP 1 OF 5</div>
            <div class="icip-panel__heading">Branded Calling Setup</div>
            <div class="icip-panel__subheading">Configure your program identity</div>

            <div class="icip-form">
              <div class="icip-form__field">
                <div class="icip-form__label">Program Name</div>
                <div class="icip-form__input icip-form__input--pname"><span class="icip-typing icip-typing--pname">First Orion Support</span></div>
              </div>
              <div class="icip-form__field">
                <div class="icip-form__label">Display Name</div>
                <div class="icip-form__input icip-form__input--dname"><span class="icip-typing icip-typing--dname">First Orion Client Care</span></div>
              </div>
              <div class="icip-form__field">
                <div class="icip-form__label">Call Purpose</div>
                <div class="icip-form__select icip-form__select--purpose"><span class="icip-typing icip-typing--purpose">Customer Service</span></div>
              </div>
            </div>

            <div class="icip-panel__primary">Next →</div>
          </div>

          <div class="icip-panel icip-panel--1" *ngIf="active === 1">
            <span class="icip-pointer" aria-hidden="true"></span>
            <div class="icip-panel__badge">STEP 2 OF 5</div>
            <div class="icip-panel__heading">Add Phone Numbers</div>
            <div class="icip-panel__subheading">Register your outbound lines</div>

            <div class="icip-tabs">
              <div class="icip-tabs__active">Manual Entry</div>
              <div class="icip-tabs__inactive">Multiple Numbers</div>
            </div>

            <div class="icip-form__label">Phone Number</div>
            <div class="icip-row">
              <div class="icip-row__input icip-row__input--phone"><span class="icip-typing icip-typing--phone">(501) 555-0199</span></div>
              <div class="icip-row__btn">+ Add</div>
            </div>

            <div class="icip-form__label">Added Numbers (3)</div>
            <div class="icip-list">
              <div class="icip-list__item"><span>(501) 555-0100</span></div>
              <div class="icip-list__item is-alt"><span>(501) 555-0101</span></div>
              <div class="icip-list__item icip-list__item--reveal"><span>(501) 555-0199</span><span class="icip-pill icip-pill--new">NEW</span></div>
            </div>
          </div>

          <div class="icip-panel icip-panel--2" *ngIf="active === 2">
            <span class="icip-pointer" aria-hidden="true"></span>
            <div class="icip-panel__badge">STEP 3 OF 5</div>
            <div class="icip-panel__heading">Review &amp; Submit</div>
            <div class="icip-panel__subheading">Confirm your program before going live</div>

            <div class="icip-summary">
              <div class="icip-summary__row icip-summary__row--sum1"><span>Program Name</span><b><span class="icip-typing icip-typing--sum1">First Orion Support</span></b></div>
              <div class="icip-summary__row icip-summary__row--sum2"><span>Display Name</span><b><span class="icip-typing icip-typing--sum2">First Orion Client Care</span></b></div>
              <div class="icip-summary__row icip-summary__row--sum3"><span>Call Purpose</span><b><span class="icip-typing icip-typing--sum3">Customer Service</span></b></div>
            </div>

            <div class="icip-ready icip-ready--box">
              <div class="icip-ready__icon">✓</div>
              <div>
                <div class="icip-ready__title">Numbers Ready</div>
                <div class="icip-ready__desc">3 numbers ready for registration</div>
              </div>
              <div class="icip-ready__tag">READY</div>
            </div>

            <div class="icip-panel__primary icip-panel__primary--step3">Submit Program</div>
          </div>

          <div class="icip-panel icip-panel--3" *ngIf="active === 3">
            <div class="icip-panel__badge">STEP 4 OF 5</div>
            <div class="icip-panel__heading">Branded Calling</div>
            <div class="icip-panel__subheading">3 programs registered</div>

            <div class="icip-table">
              <div class="icip-table__head">
                <span>Program</span><span>Display Name</span><span>Status</span><span>Numbers</span>
              </div>
              <div class="icip-table__row is-muted">
                <span>Fraud Alert Line</span><span>First Orion Alerts</span><span><em>Active</em></span><span>124</span>
              </div>
              <div class="icip-table__row is-muted">
                <span>Support Desk</span><span>FO Support</span><span><em>Active</em></span><span>48</span>
              </div>
              <div class="icip-table__row is-highlight icip-table__row--reveal">
                <span><b>First Orion Support</b></span><span>First Orion Client Care</span><span><em>Active</em></span><span>3</span>
              </div>
            </div>

            <div class="icip-toast icip-toast--reveal">Program created successfully</div>
          </div>

          <div class="icip-panel icip-panel--4" *ngIf="active === 4">
            <span class="icip-pointer" aria-hidden="true"></span>
            <div class="icip-panel__badge">STEP 5 OF 5</div>
            <div class="icip-panel__heading">Branded Call Performance</div>
            <div class="icip-panel__subheading">First Orion Support · Last 30 days</div>

            <div class="icip-cards">
              <div class="icip-card">
                <div class="icip-card__label">Total Calls</div>
                <div class="icip-card__value">{{ step5TotalCalls | number }}</div>
                <div class="icip-card__sub">↑ 12% vs last period</div>
              </div>
              <div class="icip-card">
                <div class="icip-card__label">Answer Rate</div>
                <div class="icip-card__value">{{ step5AnswerRate }}%</div>
                <div class="icip-card__sub">↑ 3% vs last period</div>
              </div>
              <div class="icip-card">
                <div class="icip-card__label">Callback Rate</div>
                <div class="icip-card__value">{{ step5CallbackRate | number: '1.1-1' }}%</div>
                <div class="icip-card__sub">↑ 1.2% vs last period</div>
              </div>
            </div>

            <div class="icip-chart">
              <div class="icip-chart__title">Estimated Call Volume</div>
              <div class="icip-chart__fake">
                <div class="icip-chart__loading">Loading chart...</div>
                <div class="icip-chart__canvas" echarts [options]="step5ChartOptions" [autoResize]="true" (chartInit)="onStep5ChartInit($event)"></div>
              </div>
            </div>
          </div>
          </div>
        </div>

        <div class="icip-walkthrough__dots" aria-label="Walkthrough dots">
          <button
            type="button"
            class="icip-walkthrough__dot"
            *ngFor="let _ of steps; let i = index"
            (click)="selectStep(i)"
            [class.is-active]="i === active"
            [style.width.px]="i === active ? 18 : 6"
          ></button>
        </div>
      </div>
    </div>
  </div>
</section>
